import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

// Эти значения подставляются во время сборки
// Значения для контуров лежат в .maki/helm/config
// Значения для локального запуска лежат в .env
const dsn = '__SENTRY_DSN__';
const environment = '__SENTRY_ENVIRONMENT__';
const release = '__SENTRY_RELEASE__';

export const initSentry = () => {
  try {
    Sentry.init({
      dsn,
      environment,
      release,
      ignoreErrors: ['ResizeObserver loop'],
      integrations: [
        new Integrations.BrowserTracing({
          traceFetch: false,
          traceXHR: false,
        }),
      ],
    });
  } catch (ignore) {
    /* ignore */
  }
};
